<script>
import "@/assets/scss/frontend/topbar.scss";
// import userPortal from "./userPortal";
import User from "../../components/map/feature/user/User.vue";
import MenuPortal from "./MenuPortal";

export default {
  name: "TopbarHeaderPortal",
  components: {
    User,
    MenuPortal
  },
  props: {
    stickyBar: Boolean,
    isLight: Boolean,
  },
  computed: {
    smallScreen() {
      return window.screen.width <= 991;
    }
  },
  data() {
    return {
      isFixed: false,
      topBarLight: false,
    };
  },

  mounted() {
    window.addEventListener("scroll", function (ev) {
      ev.preventDefault();
      var navbar = document.getElementById("navbar");
      if (navbar) {
        if (
          document.body.scrollTop >= 50 ||
          document.documentElement.scrollTop >= 50
        ) {
          navbar.classList.add("is-sticky");
        } else {
          navbar.classList.remove("is-sticky");
        }
      }
    });
    if (this.stickyBar === true) {
      this.isFixed = true;
    } else {
      this.isFixed = false;
    }

    if (this.isLight === true) {
      this.topBarLight = true;
    } else {
      this.topBarLight = false;
    }
  },
  methods: {},
};
</script>
<template>
  <nav class="navbar navbar-expand-lg navbar-landing py-0" id="navbar"
       :class="{ 'fixed-top': isFixed, 'navbar-light': topBarLight }">
    <b-container id="header__container--portal">
      <b-link class="navbar-brand" href="/">
        <img
          src="@/assets/images/logo-thai-nguyen.svg"
          class="card-logo card-logo-dark navbar--brand__logo"
          alt="logo dark"
          height="17"
        />
        <img
          src="@/assets/images/logo-thai-nguyen.svg"
          class="card-logo card-logo-light navbar--brand__logo"
          alt="logo light"
          height="17"
        />
      </b-link>
      <button class="navbar-toggler py-0 fs-20 text-body" type="button" data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasTop" aria-controls="offcanvasTop">
        <i class="mdi mdi-menu"></i>
      </button>

      <b-collapse class="navbar-collapse" id="navbarSupportedContent">
        <MenuPortal></MenuPortal>
      </b-collapse>
      <div v-show="!smallScreen" class="nav-item user">
        <User></User>
      </div>
    </b-container>
  </nav>
  <div class="offcanvas offcanvas-top bg-primary" tabindex="-1" id="offcanvasTop"
       aria-labelledby="offcanvasTopLabel" style="min-height:55vh;">
    <div class="offcanvas-body p-2">
      <div class="d-flex justify-content-between align-items-center border-bottom px-2 pb-1" style="border: #cccccc">
        <b-link class="navbar-brand" href="/">
          <img src="@/assets/images/logo-thai-nguyen.svg" class="card-logo card-logo-dark navbar--brand__logo"
               alt="logo dark" height="15"/>
          <img src="@/assets/images/logo-thai-nguyen.svg" class="card-logo card-logo-light navbar--brand__logo"
               alt="logo light" height="15"/>
        </b-link>
        <User></User>
      </div>
      <MenuPortal></MenuPortal>
      <div class="mt-2 text-center">
        <button class="btn btn-soft-danger btn-md btn-icon rounded-circle light-dark-mode text-white-75" type="button"
                data-bs-toggle="offcanvas" data-bs-target="#offcanvasTop" aria-controls="offcanvasTop">
          <div class="btn-content"><i class="ri-close-fill fs-22"></i></div>
        </button>
      </div>
    </div>
  </div>
</template>
<style scoped>
@media screen and (max-width: 991px) {
  #header__container--portal {
    flex-direction: row-reverse;
    justify-content: space-between;
  }

  #offcanvasTop {
    color: #cccccc;
  }
}
</style>
